/* Copyright 2013 - 2024 Waiterio LLC */
import getMultilocaleApiUrl from '@monorepo/env/getMultilocaleApiUrl.js'

export default url =>
  fetch(`${getMultilocaleApiUrl()}/api/fetch-landing-page?url=${url}`)
    .then(response => response.text())
    .catch(error => error)
